import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { StoresResolver } from './resolvers/stores.resolver';
import { StoreStateResolver } from './resolvers/storeState.resolver';
import { ProductStateResolver } from './resolvers/productState.resolver';
import { CategoriesResolver } from './resolvers/categories.resolver';
import { AuthGuardService } from './providers/auth.gaurd';
import { NearbyStoresResolver } from './resolvers/nearbyStores.resolver';
import { ProductsResolver } from './resolvers/products.resolver';
import { StoreDetailsResolver } from './resolvers/storeDetails.resolver';
import { ContentResolver } from './resolvers/content.resolver';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    canActivate: [AuthGuardService],
    resolve: { 
      categoryData: CategoriesResolver,
      content: ContentResolver
    }
  },
  {
    path: 'shopping-list',
    loadChildren: () => import('./pages/shopping-list/shopping-list.module').then(m => m.ShoppingListPageModule)
  },
  {
    path: 'store-search/:spotType',
    loadChildren: () => import('./pages/store-search/store-search.module').then(m => m.StoreSearchPageModule),
    canActivate: [AuthGuardService],
    resolve: { storesData: NearbyStoresResolver }
  },
  {
    path: 'product-search/:id',
    loadChildren: () => import('./pages/product-search/product-search.module').then(m => m.ProductSearchPageModule),
    canActivate: [AuthGuardService],
    resolve: {
      store: StoreStateResolver
    }
  },
  {
    path: 'search-result/cat/:category',
    loadChildren: () => import('./pages/search-result/search-result.module').then(m => m.SearchResultPageModule),
    canActivate: [AuthGuardService],
    resolve: { 
      products: ProductsResolver 
    }
  },
  {
    path: 'stores/:productSku',
    loadChildren: () => import('./pages/stores/stores.module').then(m => m.StoresPageModule),
    canActivate: [AuthGuardService],
    resolve: {
      stores: StoresResolver,
      product: ProductStateResolver
    }
  },
  {
    path: 'product/:id',
    loadChildren: () => import('./pages/product/product.module').then(m => m.ProductPageModule),
    canActivate: [AuthGuardService],
    resolve: {
      storeDetails: StoreDetailsResolver,
      store: StoreStateResolver,
      product: ProductStateResolver
    }
  },
  {
    path: 'spot-form/:id',
    loadChildren: () => import('./pages/spot-form/spot-form.module').then(m => m.SpotFormPageModule),
    canActivate: [AuthGuardService],
    resolve: {
      store: StoreStateResolver,
      product: ProductStateResolver
    }
  },
  {
    path: 'store-spot-form/:id',
    loadChildren: () => import('./pages/store-spot-form/store-spot-form.module').then(m => m.StoreSpotFormPageModule),
    canActivate: [AuthGuardService],
    resolve: {
      store: StoreStateResolver,
    }
  },
  {
    path: 'spot-confirm/:id',
    loadChildren: () => import('./pages/spot-confirm/spot-confirm.module').then(m => m.SpotConfirmPageModule),
    canActivate: [AuthGuardService],
    resolve: {
      store: StoreStateResolver,
      product: ProductStateResolver
    }
  },
  {
    path: 'help',
    loadChildren: () => import('./pages/help/help.module').then(m => m.HelpPageModule)
  },
  {
    path: 'test',
    loadChildren: () => import('./pages/test/test.module').then(m => m.TestPageModule)
  },
  {
    path: 'test-store/:retailer/:pid/:zip',
    loadChildren: () => import('./pages/test-store/test-store.module').then(m => m.TestStorePageModule)
  },
  {
    path: 'about',
    loadChildren: () => import('./pages/about/about.module').then(m => m.AboutModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'register2',
    loadChildren: () => import('./pages/register/register2/register2.module').then(m => m.Register2PageModule)
  },
  {
    path: 'register3',
    loadChildren: () => import('./pages/register/register3/register3.module').then(m => m.Register3PageModule)
  },
  {
    path: 'register4',
    loadChildren: () => import('./pages/register/register4/register4.module').then(m => m.Register4PageModule)
  },
  {
    path: 'register5',
    loadChildren: () => import('./pages/register/register5/register5.module').then(m => m.Register5PageModule)
  },
  {
    path: 'downloads',
    loadChildren: () => import('./pages/downloads/downloads.module').then(m => m.DownloadsPageModule)
  },
  {
    path: '**',
    redirectTo: '/home',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
